"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Marketplace: true
};
exports.Marketplace = void 0;

var _marketplace = require("./marketplace.reducer");

var _marketplace2 = _interopRequireDefault(require("./marketplace.epics"));

var _useGetProductById = require("./Products/hooks/useGetProductById");

var _ProductItem = require("./Products/components/ProductItem");

var _marketplace3 = require("./marketplace.types");

Object.keys(_marketplace3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _marketplace3[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marketplace3[key];
    }
  });
});
var Marketplace = {
  name: 'marketplace',
  reducer: _marketplace.marketplace,
  epics: _marketplace2.default,
  hooks: {
    useGetProductById: _useGetProductById.useGetProductById
  },
  ConnectedDefaultProductItem: _ProductItem.ConnectedDefaultProductItem,
  ConnectedTextProductItem: _ProductItem.ConnectedTextProductItem,
  ConnectedSelectableProductItem: _ProductItem.ConnectedSelectableProductItem,
  DefaultProductItem: _ProductItem.DefaultProductItem,
  TextProductItem: _ProductItem.TextProductItem,
  SelectableProductItem: _ProductItem.SelectableProductItem
};
exports.Marketplace = Marketplace;